export const errorMapping = {
  mitigationMessageError: `<p>Infelizmente não podemos prosseguir com a compra, pois o CNPJ da empresa pode estar classificado em algum desses status:</p><ul>    <li> Seu CPF não pertença ao quadro societário da empresa cadastrada </li>    <li> Empresa inativa na receita federal </li>    <li> Ramos de atividades não comercializáveis </li>    <li> Empresas com apontamento de inconsistências </li></ul><p>Ainda tem dúvidas? Acesse a <a href="https://www.serasaempreendedor.com.br/auto-servico/enviar-mensagem">área de atendimento</a>.</p>`,
  requiredBusinessDataNotFound:
    'Não foi possível buscar todos os dados de empresa necessários para a continuação da venda. Tente novamente em alguns instantes.',
  requiredUserDataNotFound:
    'Não foi possível buscar todos os dados de cliente necessários para a continuação da venda. Tente novamente em alguns instantes.',
  requiredIntegrationDataNotFound: 'Não foi possível buscar dados necessários para a continuação da venda. Tente novamente em alguns instantes.',
  missingUserAndBusinessId: 'Não foi possível buscar dados necessários para a continuação da venda.',
  provisioningDataIntegrationError: 'Erro na integração de dados de compra. Tente novamente em alguns instantes.',
  updateAddressFromZipcodeIntegration: 'Informe um CEP válido',
  unexpectedError: 'Ocorreu um erro que não estavámos esperando. Tente novamente em alguns instantes.',
  cartIntegrationError: 'Não foi possível obter itens do carrinho. Tente novamente mais tarde.',
  timeOutError: 'TimeOut de processamento de pagamento',
  termOfUsedIntegrationError: 'Não foi possível obter os termos de uso. Tente novamente mais tarde.',
  invalidPaymentOption: 'Número de parcelas selecionada não é válida para este produto.',
  checkIfAlreadyPurchasedError: 'Ocorreu um erro que não estavámos esperando. Tente novamente em alguns instantes.',
  noCompanyNameFound: 'Não foi possível obter a razão social da empresa. Por favor informe a razão social.',
  userNotAssociateError: 'Infelizmente essa solução ainda não está disponível para você. Identificamos que o seu CPF não pertence ao quadro societário da empresa cadastrada. Ainda tem dúvidas? Acesse a nossa <a href="https://serasaempreendedor.zendesk.com/hc/pt-br/requests/new"> Central do usuário.</a>',
  invalidChecksum: 'Falha de comunicação. Infelizmente não conseguimos prosseguir com a sua compra, clique no voltar e tente novamente.',
  invalidTokenTelevendas: 'Não foi possível buscar os dados necessários para a continuação da televenda. Por favor entre em contato com o atendimento.',
  RECENT_PURCHASE_MODAL: 'Deseja prosseguir com a compra ? Identificamos que você realizou uma compra recente deste produto.'

};

export const braspagReasonCodeOld = {
  'Cartão Expirado.': 'O Cartão de crédito utilizado já expirou, por favor tente novamente com um cartão de crédito válido.',
  'Cartão Bloqueado.': 'O Cartão de crédito utilizado está bloqueado, por favor tente novamente com um cartão de crédito válido.',
  'Time Out.': 'O Sistema de cobrança do cartão de crédito está indisponível no momento, tente novamente mais tarde.',
  'Problemas com o Cartão de Crédito.': 'Encontramos problemas ao validar o cartão de crédito informado, por favor revise as informações e tente novamente.',
  'Cartão Cancelado.': 'O Cartão de Crédito utilizado está cancelado, por favor tente novamente com um cartão de crédito válido.',
  'Não Autorizada': 'Transação não autorizada pelo sistema de cobrança.',
  'Transação não autorizada.': 'Transação não autorizada pelo sistema de cobrança.',
  'AffiliationNotFound': 'Não encontramos o provedor especificado para a compra.',
  'IssuficientFunds': 'Não foi possível concluir com o pagamento por saldo insuficiente no cartão de crédito.',
  'CouldNotGetCreditCard': 'Não foi possível obter cartão de crédito para recorrência, tente novamente mais tarde.',
  'ConnectionWithAcquirerFailed': 'Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.',
  'InvalidTransactionType': 'Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.',
  'InvalidPaymentPlan': 'Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.',
  'Denied': 'Transação não autorizada pelo sistema de cobrança.',
  'Scheduled': 'Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.',
  'Waiting': 'Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.',
  'Authenticated': 'Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.',
  'NotAuthenticated': 'Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.',
  'ProblemsWithCreditCard': 'Encontramos problemas ao validar o cartão de crédito informado, por favor revise as informações e tente novamente.',
  'CardCanceled': 'O Cartão de Crédito utilizado está cancelado, por favor tente novamente com um cartão de crédito válido.',
  'BlockedCreditCard': 'O Cartão de crédito utilizado está bloqueado, por favor tente novamente com um cartão de crédito válido.',
  'CardExpired': 'O Cartão de crédito utilizado já expirou, por favor tente novamente com um cartão de crédito válido.',
  'AbortedByFraud': 'Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.',
  'CouldNotAntifraud': 'Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.',
  'TryAgain': 'Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.',
  'InvalidAmount': 'Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.',
  'ProblemsWithIssuer': 'Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.',
  'InvalidCardNumber': 'Número do Cartão de Crédito inválido, favor preencher novamente.',
  'TimeOut': 'O Sistema de cobrança do cartão de crédito está indisponível no momento, tente novamente mais tarde.',
  'CartaoProtegidoIsNotEnabled': 'Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.',
  'PaymentMethodIsNotEnabled': 'Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.',
  'InvalidRequest': 'Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.',
  'InternalError': 'Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.',
};

export const braspagReasonCode = {
  'Erro Genérico': 'Transação não autorizada.',
  'Tente novamente dentro de algumas horas': 'Tente novamente dentro de algumas horas, transação não disponível para reembolso.',
  'A solicitação falhou': 'Entre em contato com a Rede. A solicitação falhou.',
  'Reembolso não encontrado': 'Reembolso não encontrado.',
  'Por favor, tente novamente': 'Tente novamente!',
  'Reembolso parcial não disponível': 'Reembolso parcial não disponível.',
  'Reembolso processado com sucesso': 'Reembolso processado com sucesso!',
  'Soma dos reembolsos de valor superiores ao valor processado disponível para reembolso': 'Soma dos reembolsos de valor superiores ao valor processado disponível para reembolso.',
  'Soma dos reembolsos de valor maiores que o valor da transação': 'Soma dos reembolsos de valor maiores que o valor da transação.',
  'Transação já cancelada': 'Transação já cancelada.',
  'Transação com prazo expirado para reembolso': 'Transação com prazo expirado para reembolso.',
  'Transação não encontrada': 'Transação não encontrada.',
  'Não autorizado': 'Não autorizado.',
  'Transação em dólar zero negada': 'Transação em dólar zero negada.',
  'Transação com dólar zero não permitida para este cartão': 'Transação com dólar zero não permitida para este cartão.',
  'Entre em contato com a Rede': 'Não autorizado, entre em contato com a rede.',
  'O portador solicitou o fim das recorrências no emissor': 'Não autorizado, o portador solicitou o fim das recorrências no emissor.',
  'Transação enviada anteriormente': 'Transação enviada anteriormente.',
  'Erro no processamento': 'Por favor, tente novamente. Erro no processamento.',
  'Código de segurança inválido': 'Código de segurança inválido. Não autorizado.',
  'Excedeu o limite de transações permitido no período': 'Excedeu o limite de transações permitido no período. Não autorizado.',
  'O cartão não pertence à rede de pagamento': 'O cartão não pertence à rede de pagamento. Não autorizado.',
  'A data de validade expirou': 'A data de validade expirou. Não autorizado.',
  'Valor não permitido para este tipo de cartão': 'Valor não permitido para este tipo de cartão. Não autorizado.',
  'Verifique a situação da loja com o emissor': 'Verifique a situação da loja com o emissor. Não autorizado.',
  'Problemas no cartão, entre em contato com o emissor': 'Problemas no cartão, entre em contato com o emissor. Não autorizado.',
  'Sucesso': 'Sucesso!',
  'Tipo de transação não permitido para este cartão': 'Tipo de transação não permitido para este cartão. Não autorizado.',
  'Entre em contato com o emissor do cartão': 'Entre em contato com o emissor do cartão. Não autorizado.',
  'Erro no processamento do emissor': 'Por favor, tente novamente. Erro no processamento do emissor.',
  'Risco moderado identificado pelo emissor': 'Risco moderado identificado pelo emissor. Não autorizado.',
  'Cartão inexistente': 'Cartão inexistente. Não autorizado.',
  'Saldo insuficiente': 'Saldo insuficiente. Não autorizado.',
  'Cartão bloqueado': 'Transação não autorizada pela administradora do cartão.',
  'Cartão restrito': 'Cartão restrito. Não autorizado.',
  'Entre em contato com o emissor': 'Entre em contato com o emissor. Transação não autorizada.',
  'ConnectionWithAcquirerFailed': "Erro ao enviar solicitação para adquirente. Tente novamente mais tarde.",
  'Time Out': "Erro ao enviar solicitação para adquirente. Tente novamente.",
  'BlockedCreditCard': "Transação não autorizada pela administradora do cartão.",
  'Denied': 'Transação não autorizada pelo emissor do cartão.',
  'CardCanceled': 'Transação não autorizada pela administradora do cartão.',
  'ProblemsWithCreditCard': "Transação não autorizada pela administradora do cartão.",
  'CardExpired': 'Cartão vencido.',
  'BP901': 'Ocorreu um erro a realizar a transação.',
  'Comerciante inválido': 'Transação não autorizada.',
  'Recolher Cartão (não há fraude)': 'Transação não autorizada pelo emissor do cartão.',
  'Transação não autorizada': 'Transação não autorizada pelo emissor do cartão.',
  'Erro por mudança de chave dinâmica': 'Transação não processada. Por favor, tente novamente mais tarde.',
  'Autorizacao negada': 'Transação não autorizada pelo emissor do cartão.',
  'Erro no Cartão': 'Transação não autorizada.',
  'Número Cartão Inválido': 'Número de cartão inválido.',
  'Emissor não localizado - BIN incorreto': 'Número de cartão inválido.',
  'Problema no Adquirente': 'Transação não autorizada. Entre em contato com o emissor do cartão.',
  'Valor da parcela inválida': 'Verifique o número de parcelas selecionado. Caso o erro persista, entre em contato como emissor do cartão.',
  'Erro de Formato (Mensageira)': 'Transação não autorizada.',
  'Função Incorreta (Crédito)': 'Por favor, utilize um cartão com a função "crédito" ativa.',
  'Cartão Perdido': 'Transação não permitida. Por favor, entre em contato com o emissor do cartão.',
  'Cartão Roubado': 'Transação não permitida. Por favor, entre em contato com o emissor do cartão.',
  'Cartão Vencido / Data expiração inválida': 'Cartão vencido.',
  'Transação não permitida para o cartão': 'Transação não permitida. Por favor, entre em contato com o emissor do cartão.',
  'Suspeita de Fraude': 'Transação não autorizada.',
  'Valor excedido ou Saque': 'Transação não autorizada. Por favor, entre em contato com o emissor do cartão.',
  'Cartão doméstico - Transação Internacional': 'Cartão doméstico não autorizado para compras internacionais.',
  'Violação de Segurança - Suspeita de Fraude': 'Transação não autorizada. Por favor, entre em contato com o emissor do cartão.',
  'Transação não autorizada. Limite excedido/sem saldo.': 'Transação não autorizada. Por favor, entre em contato com o emissor do cartão.',
  'Excedidas tentativas de senha ou compras': 'Transação não autorizada. Por favor, entre em contato com o emissor do cartão.',
  'Conta destino inválida ou inexistente': 'Transação não autorizada. Por favor, entre em contato com o emissor do cartão.',
  'Cartão Novo sem Desbloqueio': 'Cartão bloqueado. Entre em contato com o emissor do cartão.',
  'Cartão inválido': 'Transação não autorizada.',
  'Token: Invalid token.': 'Transação não autorizada. Por favor, entre em contato com o emissor do cartão.',
  'Emissor fora do ar': 'Sistema do emissor do cartão está indisponível no momento, tente novamente mais tarde.',
  'Transação negada por infração de lei': 'Transação não autorizada. ',
  'Transação não autorizada.': 'Transação não autorizada. Por favor, entre em contato com o emissor do cartão.',
  'Falha do Sistema': 'Transação não processada. Por favor, tente novamente mais tarde.',
  'Valor não permitido para essa transação.': 'Por favor, verifique o valor inserido.',
  'Credit Card Expiration Date is invalid': 'Data de vencimento inválida.',
  'Tempo Excedido': 'Transação não processada. Por favor, tente novamente mais tarde.',
  'Falha na operacao': 'Transação não processada. Por favor, tente novamente mais tarde.',
  'Transação não autorizada. Ligue Emissor': 'Transação não autorizada. Por favor, entre em contato com o emissor do cartão.',
  'Transação não permitida para o cartão / Cartão Perdido / Cartão Roubado': 'Transação não autorizada. Por favor, entre em contato com o emissor do cartão.',
  'Transação não permitida.': 'Transação não permitida. Por favor, entre em contato com o emissor do cartão.',
  'Transação não autorizada. Código de segurança inválido.': 'Transação não autorizada.',
  'Não foi possível concluir a venda. Caso o erro persista, tente novamente mais tarde': 'Não foi possível concluir a venda. Caso o erro persista, tente novamente mais tarde',
  'Erro inesperado': 'Erro inesperado.',
  'Card Number length exceeded': 'Transação não autorizada.',
  'Not Authorized': 'Transação não autorizada.',
  'Card Expired': 'Cartão expirado.',
  'Blocked Card': 'Cartão bloqueado.',
  'Card Canceled': 'Transação não autorizada pela administradora do cartão.',
  'Problems with Creditcard': 'Transação não autorizada.',
  'Timeout': 'O Sistema de cobrança do cartão de crédito está indisponível no momento, tente novamente mais tarde.'
};

export const adyenReasonCode = {
  "Refused": "A transação foi recusada.",
  "Referral":"Referências.",
  "Acquirer Error": "A transação não foi concluída devido a um erro ocorrido no lado do adquirente.",
  "Blocked Card": "O cartão está bloqueado.",
  "Expired Card": "O cartão expirou.",
  "Invalid Amount": "Ocorreu uma incompatibilidade de valor durante o processo da transação.",
  "Invalid Card Number": "O número do cartão especificado está incorreto ou inválido.",
  "Issuer Unavailable": "Não foi possível entrar em contato com o banco para autorizar a transação.",
  "Not supported": "O banco recusou este tipo de transação.",
  "3D Not Authenticated": "A autenticação 3D Secure não foi executada ou não foi executada com sucesso.",
  "Not enough balance": "Saldo insuficiente.",
  "Acquirer Fraud": "Possível fraude.",
  "Cancelled": "A transação foi cancelada.",
  "Shopper Cancelled": "Transação foi cancelada.",
  "Invalid Pin": "O PIN especificado está incorreto ou inválido.",
  "Pin tries exceeded": "Número de tentativas de inserir o PIN foi excedida.",
  "Pin validation not possible": "Não é possível validar o número PIN especificado.",
  "FRAUD": "As verificações de risco de pré-autorização sinalizam a transação como fraudulenta e, devido a isso, foi recusada.",
  "Not Submitted": "A transação não foi enviada corretamente para processamento.",
  "FRAUD-CANCELLED": "As verificações de risco de pré-autorização e pós-autorização sinalizam a transação como fraudulenta e, devido a isso, foi recusada.",
  "Transaction Not Permitted": "Transação não autorizada. Por favor, entre em contato com o emissor do cartão.",
  "CVC Declined": "CVC inválido.",
  "Restricted Card": "Cartão Restrito, ou inválido neste país.",
  "Revocation Of Auth": "Revogação da Ordem de Autorização",
  "Declined Non Generic": "Transação não autorizada.",
  "Withdrawal amount exceeded": "O valor de saque permitido foi excedido.",
  "Withdrawal count exceeded": "O número de saques permitidos foi excedido.",
  "Issuer Suspected Fraud": "Transação suspeita de fraude.",
  "AVS Declined": "Os dados de endereço estão incorretos.",
  "Card requires online pin": "O banco exige que seja inserido um PIN online.",
  "No checking account available on Card": "O banco requer uma conta corrente para concluir a compra.",
  "No savings account available on Card": "O banco exige uma conta poupança para concluir a compra.",
  "Mobile pin required": "O banco exige que seja inserido um PIN móvel.",
  "Contactless fallback": "Tente novamente utilizando outra forma de pagamento",
  "Authentication required": "Tente novamente com o 3D Secure.",
  "RReq not received from DS": "Não foi possível concluir a transação.",
  "Current AID is in Penalty Box.": "A rede de pagamento não pode ser alcançada. Repita a transação com um método de pagamento diferente.",
  "CVM Required Restart Payment": "É necessário um PIN ou assinatura. Repita a transação.",
  "3DS Authentication Error": "A autenticação 3D Secure falhou devido a um problema na rede ou no emissor do cartão. Repita a transação ou altere a forma de pagamento.",
  "Could not find an acquirer account": "Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.",
  "Cryptographic failure": 'Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.',

  "Approved or completed successfully": "Transação cancelada",
  "Refer to card issuer": "Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.",
  "Invalid merchant": "Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.",
  "Capture card / Pick-up": "Transação suspeita de fraude.",
  "Do not honor": "O banco recusou a transação.",
  "Do not honor (Decline - Insufficient FundsBAL=...)": "Limite de crédito insuficiente. Utilize outro cartão ou altere a forma de pagamento.",
  "Do not honor (Decline Card Inv)": "Cartão inválido. Utilize outro cartão ou altere a forma de pagamento.",
  "Do not honor (Decline Expired)": "Cartão expirado. Utilize outro cartão ou altere a forma de pagamento.",
  "Do not honor (Decline InactiveBAL=0.00)": "Cartão bloqueado. Utilize outro cartão ou altere a forma de pagamento.",
  "Insufficient funds - Card working balance is insufficient": "Limite de crédito insuficiente. Utilize outro cartão ou altere a forma de pagamento.",
  "Error": "O pagamento não pôde ser autorizado. Tente novamente ou utilize outro cartão ou outra forma de pagamento.",
  "Pickup card, special condition": "Transação suspeita de fraude.",
  "Partial approval": "Transação cancelada. Utilize outro cartão ou altere a forma de pagamento.",
  "Invalid transaction": "Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.",


  "Invalid issuer": "Número do cartão não está dentro de um intervalo de números de cartão suportado pelo esquema.",
  "Re-enter transaction": "O comprador deve tentar novamente. O emissor do cartão não fornece mais informações sobre por que a transação não foi processada.",
  "Card already issued - Issue Gift Card Transaction used on a card that has already been reloaded": "Emissor do cartão indicou um problema com o número do cartão. O comprador deve tentar novamente, usar um método de pagamento alternativo ou entrar em contato com seu banco.",
  "Card not initialized": "Emissor do cartão indicou que o cartão não foi inicializado. O comprador deve tentar novamente, usar um método de pagamento alternativo ou entrar em contato com seu banco.",
  "Unable to locate record on file": "Emissor do cartão não reconhece os detalhes do cartão de crédito. O comprador deve verificar as informações do cartão e tentar novamente.",
  "Format error": "Emissor do cartão não reconhece os detalhes da transação inseridos. Isso ocorre devido a um erro de formato. O comprador deve verificar as informações da transação e tentar novamente.",

  "Fraud - Pick Up": "Transação suspeita de fraude.",
  "No credit account": "Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.",
  "Function not supported / Requested function not supported": "Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.",
  "Lost card": "Transação suspeita de fraude.",
  "Stolen card": "Transação suspeita de fraude.",
  "Decline": "Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.",
  "No Cheque account": "Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.",
  "No Savings account": "Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.",
  "Transaction not permitted to issuer/cardholder": "Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.",
  "Transaction not permitted to acquirer/terminal": "Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.",
  "Suspected fraud": "Transação suspeita de fraude.",

  "Exceeds withdrawal amount limit(s) / Withdrawal amount limit exceeded": "Limite de crédito insuficiente. Utilize outro cartão ou altere a forma de pagamento.",
  "Restricted card": "Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.",
  "Security violation": "Suspeita de fraude.",
  "Exceeds withdrawal count limit / Withdrawal count limit exceeded": "Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.",
  "Contact Card Issuer": "Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.",
  "Allowable number of PIN tries exceeded": "Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.",
  "Invalid/nonexistent account specified (general)": "Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.",
  "Credit issuer unavailable": "Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.",
  "Cannot Verify PIN": "Não foi possível validar o número PIN especificado.",
  "PIN Validation not possible": "Não foi possível validar o número PIN especificado.",
  "Unacceptable PIN—Transaction Declined—Retry": "Não foi possível validar o número PIN especificado. Tente novamente ou utilize outro cartão ou outra forma de pagamento.",
  "Issuer unavailable or switch inoperative": "Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.",
  "Destination cannot be found for routing / Unable to route transaction": "Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.",
  "Transaction cannot be completed; violation of law": "Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.",
  "System error": "Tivemos um problema ao processar a transação. Tente novamente mais tarde ou tente outra forma de pagamento.",

  "Deny": "Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.",
  "Do not honour": "Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.",
  "Expired Card / Invalid Expiration Date": "Cartão expirado. Utilize outro cartão ou altere a forma de pagamento.",
  "Invalid card number": "Número do cartão especificado está incorreto ou inválido. Confira as informações do cartão e tente novamente.",
  "Unable to determine variant": "Transação não autorizada. Utilize outro cartão ou altere a forma de pagamento.",

  "Insufficient funds/over credit limit": "Desculpe, a transação não pode ser concluída. Por favor, verifique o limite de crédito e tente novamente.",
  "Fraud/Security": "Parece que houve um problema com a transação. Por motivos de segurança, ela foi recusada. Recomendamos entrar em contato com o emissor do seu cartão.",
  "Policy": "Desculpe, a transação foi recusada devido a um problema com o cartão. Por favor, verifique se as informações do cartão estão corretas ou tente usar outro cartão."
};

export const braspagTryAgainErrors = {
  'Por favor, tente novamente': 'Por favor, tente novamente!',
  'Erro no processamento': 'Por favor, tente novamente. Erro no processamento.',
  'Erro no processamento do emissor': 'Por favor, tente novamente. Erro no processamento do emissor.',
  'Time Out': "Erro ao enviar solicitação para adquirente. Tente novamente.",
  'Não foi possível concluir a venda. Caso o erro persista, tente novamente mais tarde': 'Não foi possível concluir a venda. Caso o erro persista, tente novamente mais tarde',
  'Tempo Excedido': 'Transação não processada. Por favor, tente novamente mais tarde.',
  'Falha na operacao': 'Transação não processada. Por favor, tente novamente mais tarde.',
  'Falha do Sistema': 'Transação não processada. Por favor, tente novamente mais tarde.',
  'Emissor fora do ar': 'Sistema do emissor do cartão está indisponível no momento, tente novamente mais tarde.',
  'Erro por mudança de chave dinâmica': 'Transação não processada. Por favor, tente novamente mais tarde.',
  'ConnectionWithAcquirerFailed': "Erro ao enviar solicitação para adquirente. Tente novamente mais tarde.",
  'Timeout': 'O Sistema de cobrança do cartão de crédito está indisponível no momento, tente novamente mais tarde.',
}

export const sydleOneModalErrors = {
  "RECENT_PURCHASE_MODAL": "RECENT_PURCHASE_MODAL",
  "MODAL_FRAUDNET_PENDING_PURCHASE": "MODAL_FRAUDNET_PENDING_PURCHASE",
  "FRAUDNET_REJECT": "FRAUDNET_REJECT",
  "MODAL_EXISTS_BANKBILLET_MENSAL_PLAN": "MODAL_EXISTS_BANKBILLET_MENSAL_PLAN",
  "MODAL_EXISTS_BANKBILLET_SDSN": "MODAL_EXISTS_BANKBILLET_SDSN",
  "MODAL_EXISTS_BANKBILLET_MONITORE": "MODAL_EXISTS_BANKBILLET_MONITORE",
  "MODAL_EXISTS_PIX_MENSAL_PLAN": "MODAL_EXISTS_PIX_MENSAL_PLAN",
  "MODAL_EXISTS_PIX_SDSN": "MODAL_EXISTS_PIX_SDSN",
  "MODAL_EXISTS_PIX_MONITORE": "MODAL_EXISTS_PIX_MONITORE",
  "WATCHLIST_INVESTIGATE": "WATCHLIST_INVESTIGATE",
  "WATCHLIST_REJECT_PIX": "WATCHLIST_REJECT_PIX",
  "WATCHLIST_REJECT_BOLETO": "WATCHLIST_REJECT_BOLETO",
  "WATCHLIST_REJECT_CREDITCARD": "WATCHLIST_REJECT_CREDITCARD",
  "MODAL_WATCHLIST_PENDING_PURCHASE": "MODAL_WATCHLIST_PENDING_PURCHASE",
  "MODAL_EXISTS_PIX_CONSULTA": "MODAL_EXISTS_PIX_CONSULTA",
  "MODAL_EXISTS_BANKBILLET_CONSULTA": "MODAL_EXISTS_BANKBILLET_CONSULTA"
};

export function handleIntegrationError(error: any): any {
  const resultError: any = {};

  try {
    if (typeof error === 'string') {
      error = JSON.parse(error);
    }

    if (error.status !== null && error.error) {
      resultError.status = error.status;
      resultError.endpoint = error.url && error.url.substring(error.url.indexOf("/api/1"));
      resultError.name = error.name;

      resultError.handledError = !!error.error._messages.filter((message) => {
        return message.code !== null;
      });

      resultError.errors = error.error._messages.filter((message) => {
        return message.type === 'ERROR';
      });

      resultError.warnings = error.error._messages.filter((message) => {
        return message.type === 'WARNING';
      });

      resultError.errorString = `${resultError.context || "SYDLE"}:HTTP:${resultError.errorCode || resultError.status}:POST/${resultError.endpoint}:${JSON.stringify(resultError.errors.map(({ text }) => text))}:${JSON.stringify(resultError.warnings)}`;
      
      resultError.userMessage = error.error._messages[0].text;

      if (resultError.userMessage.indexOf('java') >= 0 ||
        resultError.userMessage.indexOf('Java') >= 0 ||
        resultError.userMessage.indexOf('elastic') >= 0 ||
        resultError.userMessage.indexOf('Elastic') >= 0) {
        resultError.userMessage = 'Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.';
      }
    } else {
      resultError.errorString = JSON.stringify(error);
      resultError.userMessage = 'Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.';
    }
  } catch (e) {
    resultError.errorString = JSON.stringify(error);
    resultError.userMessage = 'Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.';
  }
  return resultError;
}

export const authReasonCode = {
  '400': {
    'title': 'Serviço indisponível!',
    'contents': ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
  },
  '401': {
    'title': 'Token de autenticação inválido!',
    'contents': ['O token de autenticação utilizado está expirado ou inválido.', 'Acesse novamente o portal para obter um novo token.']
  },
  '1': {
    'title': 'Assinatura cancelada!',
    'type': 'success',
    'contents': ['O seu contrato está cancelado e portanto não pode ser realizado nenhum auto-atendimento.']
  }
};

export const bankBillet2ndCopyErrors = {
  '400': {
    'title': 'Serviço indisponível!',
    'contents': ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
  },
  '2': {
    'title': 'Contrato não encontrado!',
    'contents': ['Não foi encontrado nenhum contrato para os dados informados.']
  },
  '3': {
    'title': 'Forma de pagamento inválida!',
    'contents': ['Forma de pagamento do contrato não é boleto bancário.']
  },
  '4': {
    'title': 'Boleto bancário não encontrado!',
    'contents': ['Não encontramos o boleto bancário referente a este serviço. Tente novamente mais tarde.']
  }
};

export const pix2ndCopyErrors = {
  '400' : {
    'title': 'Serviço indisponível!',
    'contents': ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
  },
  '2': {
    'title': 'Contrato não encontrado!',
    'contents': ['Não foi encontrado nenhum contrato para os dados informados.']
  },
  '3': {
    'title': 'Forma de pagamento inválida!',
    'contents': ['Forma de pagamento do contrato não é PIX.']
  },
  '4': {
    'title': 'Serviço indisponível',
    'contents': ['Não encontramos os dados do PIX referente a este serviço. Tente novamente mais tarde.']
  },
  '5': {
    'title': 'Serviço indisponível',
    'contents': ['Não é possível emitir segunda via pois a fatura está cancelada.']
  },
  '6': {
    'title': 'Esse Pix já foi pago!',
    'type': 'success',
    'contents': ['Pode ficar tranquilo, seu pedido já consta como pago em nosso sistema.']
  },
  '7': {
    'title': 'Serviço indisponível',
    'contents': ['Não é possível emitir segunda via pois a fatura é miníma.']
  },
  '8': {
    'title': 'Serviço indisponível',
    'contents': ['Você possui uma compra sendo processada. Por favor aguarde alguns instantes...']
  },
  '9': {
    'title': 'Pedido cancelado',
    'contents': ['Seu pedido foi cancelado devido à falta de confirmação do pagamento dentro do prazo de 2 dias úteis. Caso deseje, você pode efetuar uma nova compra.']
  }
};

export const paymentMethodErrors = {
  '400': {
    'title': 'Serviço indisponível!',
    'contents': ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
  },
  '2': {
    'title': 'Contrato não encontrado!',
    'contents': ['Não foi encontrado nenhum contrato para os dados informados.']
  }
};

export const paymentChangeDataError = {
  '400': {
    'title': 'Serviço indisponível!',
    'contents': ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
  },
  '2': {
    'title': 'Contrato não encontrado!',
    'contents': ['Não foi encontrado nenhum contrato para os dados informados.']
  },
  '4': {
    'title': 'Dados de cobranção não encontrados!',
    'contents': ['Não encontramos os dados de cobrança referente a este serviço. Tente novamente mais tarde.']
  },
  '1': {
    'title': 'Contrato cancelado!',
    'contents': ['Seu contrato está cancelado.']
  },
  '3': {
    'title': 'Seu pedido está em análise!',
    'contents': ['Não se preocupe: o prazo máximo para conclusão é de até 6 horas e avisaremos por e-mail assim que o status for atualizado :)']
  }
};


export const changePackageError = {
  '400': {
    'title': 'Serviço indisponível!',
    'contents': ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
  },
  '404': {
    'title': 'Serviço indisponível!',
    'contents': ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
  },
  '1': {
    'title': 'Recarga garantida desativada!',
    'contents': ['Você deve ativar a recarga garantida para que possa alterar o pacote.']
  },
}

export const enablePackageError = {
  '400': {
    'title': 'Serviço indisponível!',
    'contents': ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
  },
  '404': {
    'title': 'Serviço indisponível!',
    'contents': ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
  },
  '1': {
    'title': 'Recarga garantida Ativa!',
    'contents': ['A sua recarga garantida já está ativa! Caso desejar, poderá alterar o pacote de créditos.']
  },
}

export const disablePackageError = {
  '400': {
    'title': 'Serviço indisponível!',
    'contents': ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
  },
  '404': {
    'title': 'Serviço indisponível!',
    'contents': ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
  },
  '1': {
    'title': 'Recarga garantida desativada!',
    'contents': ['A sua recarga garantida já está desativada!']
  },
}

export const automaticRechargePaymentChangeDataError = {
  '400': {
    'title': 'Serviço indisponível!',
    'contents': ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
  },
  '404': {
    'title': 'Serviço indisponível!',
    'contents': ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
  },
  '1': {
    'title': 'Recarga garantida desativada!',
    'contents': ['A sua recarga garantida já está desativada!']
  },
}


export const getCancelContractDataError = {
  '400': {
    'title': 'Serviço indisponível!',
    'contents': ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
  },
  '2': {
    'title': 'Contrato não encontrado!',
    'contents': ['Não foi encontrado nenhum contrato para os dados informados.']
  },
  '1': {
    'title': 'Assinatura cancelada!',
    'contents': ['O seu contrato está cancelado e portanto não pode ser realizado nenhum auto-atendimento.']
  },
  '3': {
    'title': 'Contrato inválido!',
    'contents': ['O seu contrato ainda não foi ativado, portanto não pode ser cancelado.']
  },
  '4': {
    'title': 'A renovação do plano foi reativada!',
    'contents': ['']
  },
  '5': {
    'title': 'O pedido de compra foi cancelado com sucesso!',
    'contents': ['']
  }
};

export const mappedCheckoutErrors = {
  'Opa! Cupom não está disponível': 'Opa! Cupom não está disponível',
  'Opa! Promoção não está ativa': 'Opa! Promoção não está ativa',
  'Opa! Promoção só é válida para a primeira compra do cliente': 'Opa! Promoção só é válida para a primeira compra do cliente',
  'Opa! Valor da compra não é suficiente para aplicação da promoção': 'Opa! Valor da compra não é suficiente para aplicação da promoção',
  'Opa! Valor da compra ultrapassa o limite permitido para aplicação da promoção': 'Opa! Valor da compra ultrapassa o limite permitido para aplicação da promoção',
  'Opa! Esta promoção ainda não começou': 'Opa! Esta promoção ainda não começou',
  'Opa! Esta promoção já terminou': 'Opa! Esta promoção já terminou',
  'Opa! Esta promoção já atingiu o máximo de utilizações': 'Opa! Esta promoção já atingiu o máximo de utilizações',
  'Opa! Esta promoção já foi utilizada por você': 'Opa! Esta promoção já foi utilizada por você',
  'Opa! Intervalo mínimo de utilização desta promoção ainda não foi cumprido': 'Opa! Intervalo mínimo de utilização desta promoção ainda não foi cumprido',
  'Opa! Você não pode utilizar esta promoção': 'Opa! Você não pode utilizar esta promoção',
  'Opa! Produto obrigatório não encontrado para que o desconto seja aplicado': 'Opa! Produto obrigatório não encontrado para que o desconto seja aplicado',
  'Opa! Não foi atingida a quantidade mínima do produto para que o desconto seja aplicado': 'Opa! Não foi atingida a quantidade mínima do produto para que o desconto seja aplicado',
  'Opa! Todos os produtos necessários para aplicação do desconto não foram encontrados.': 'Opa! Todos os produtos necessários para aplicação do desconto não foram encontrados.',
  'Opa! Produto não é aplicavel ao desconto.': 'Opa! Produto não é aplicavel ao desconto.',
  'Opa! Forma de pagamento não aceita pelo desconto.': 'Opa! Forma de pagamento não aceita pelo desconto.'
};
